import {Inject, Injectable} from '@angular/core';
import {Categories} from '../models/categories';

import {CartService} from './cart.service';
import {ProductService} from './product.service';
import {Cart} from '../models/CartModels/cart';
import {environment} from '../../../environments/environment';
import {MagentoCustomerService} from '../../../services/magentocustomer.service';
import {Customer} from '../models/CustomerInfo/Customer';
import {AuthService} from '../../../services/auth.service';
import {catchError, concatMap, tap} from 'rxjs/operators';
import {forkJoin, of, Subject} from 'rxjs';
import {Observable} from 'rxjs/Observable';
import {MobileConfigService} from './mobileconfig.service';
import {MobileConfig} from '../models/MobileConfig/MobileConfig';
import {CustomerAddress} from '../models/CustomerInfo/CustomerAddress';
import {Wishlist} from '../models/Wishlist/Wishlist';
import {WishlistService} from './wishlist.service';
import {MiscService} from './misc.service';
import {WINDOW} from '../../../services/window-provider';
import {BaseService} from '../../../services/base.service';
import {SystemSettingsService} from '../../admin/services/system-settings.service';


@Injectable({
    providedIn: 'root'
})
export class RegistryService {

    private CustomerLoadedEventEmitter = new Subject<Customer>();
    private CatsLoadedEventEmitter = new Subject<any>();
    private ConfigsLoadedEventEmitter = new Subject<any>();
    private CustomerAddressAddedEventEmitter = new Subject<CustomerAddress>();
    private CurrencyLoadedEventEmitter = new Subject<any>();
    private CurrencyChangedEventEmitter = new Subject<any>();
    private SettingsLoadedEventEmitter = new Subject<any>();


    public CustomerLoadedEvent$ = this.CustomerLoadedEventEmitter.asObservable();
    public CatsLoadedEvent$ = this.CatsLoadedEventEmitter.asObservable();
    public ConfigsLoadedEvent$ = this.ConfigsLoadedEventEmitter.asObservable();
    public CustomerAddressAddedEvent$ = this.CustomerAddressAddedEventEmitter.asObservable();
    public CurrencyLoadedEvent$ = this.CurrencyLoadedEventEmitter.asObservable();
    public CurrencyChangedEvent$ = this.CurrencyChangedEventEmitter.asObservable();
    public SettingsLoadedEvent$ = this.SettingsLoadedEventEmitter.asObservable();
    settings_registry = new Object();
    errorMsg: string;
    currency_data = null;
    public baseImageUrl = environment.baseCatalogUrl + '/' + environment.baseImagePath;
    fullCategoriesArr;
    Quote_id;
    test = '';
    thecart = null;
    mobileConfigs: MobileConfig = null;
    cat: any;
    settings;

    currentProduct = null;
    current_currency = 'KWD';

    // Checkout
    public checkout_step = 1;

    // Customer
    customer: Customer;
    currentLang = 'en';
    websiteId = 0;

    // wishlist
    public wishList: Wishlist = new Wishlist();

    constructor(public productsService: ProductService,
                public cartService: CartService,
                public mcustomerService: MagentoCustomerService,
                public authService: AuthService,
                @Inject(WINDOW) private window: Window,
                public miscService: MiscService,
                public baseService: BaseService,
                public mobileConfigService: MobileConfigService,
                public wishlistService: WishlistService,
                public settingsService: SystemSettingsService
    ) {
        this.currentLang = authService.currentLang;

        this.setupWebsite();


    }

    public cart: Cart = new Cart();

    public getCart() {
        return this.cart;
    }

    setupWebsite() {


        switch (this.window.location.hostname) {
            case 'localhost':
                this.websiteId = 1;
                break;

            case 'alarabiya.com.kw':
                this.websiteId = 1;
                this.current_currency = 'KWD';
                break;

            case 'sa.alarabiya.site':
                this.websiteId = 2;
                this.current_currency = 'SAR';
                break;

            default :
                this.websiteId = 1;
                this.current_currency = 'USD';
        }

        this.baseService.loadCatalogAPILink(this.window.location.hostname);

    }

    setupCurrency() {


        switch (this.window.location.hostname) {
            case 'localhost':

                break;

            case 'alarabiya.com.kw':

                this.current_currency = 'KWD';
                break;

            case 'sa.alarabiya.site':

                this.current_currency = 'SAR';
                break;

            default :

                this.current_currency = 'USD';
        }
    }

    public getWebsiteId() {
        return this.websiteId;
    }

    public load(): Promise<any> {

        // console.log('loading registry info');

        return new Promise((resolve, reject) => {


            forkJoin(
                [this.productsService.getFullCatrgories().pipe(tap((data: Categories) => {
                    this.fullCategoriesArr = data;
                    localStorage.setItem('cats', JSON.stringify(data));
                    this.EmitCatsLoadedEvent(this.fullCategoriesArr);
                })),
                    this.mobileConfigService.getMobileConfig().pipe(tap((data: MobileConfig) => {
                        this.mobileConfigs = Object.assign(new MobileConfig(), data);
                        this.EmitConfigsLoadedEvent(this.mobileConfigs);
                    })),
                    this.miscService.getAvailableCurrencies().pipe(tap((data: any) => {

                        this.currency_data = data;
                        // this.current_currency = this.current_currency;
                        //this.setupWebsite();
                        this.setupCurrency();
                        this.EmitCurrencyLoadedEvent(data);
                        this.EmitCurrencyChangedEvent(this.current_currency);

                    }))
                    ,
                    this.settingsService.getPublicSettings().pipe(tap(result => {

                        this.populateSettings(result);
                        this.EmitSettingsLoadedEvent(result);
                        this.settings = result;

                    })),

                    this.setupCustomer().pipe(tap(result => {
                    }))]
            ).subscribe(results => {
                resolve(true);
            });


        });
    }

    populateSettings(settings) {

        for (let i = 0; i < settings.settings.length; i++) {

            this.settings_registry[settings.settings[i].config_id] = settings.settings[i].value;
        }
    }

    getSettingByID(config_id) {

        if (this.settings_registry.hasOwnProperty(config_id)) {
            return this.settings_registry[config_id];
        }

        return null;

    }

    getFullCat() {


        if (this.fullCategoriesArr) {
            return this.fullCategoriesArr;
        } else {
            let stored_cats = localStorage.getItem('cats');
            if (stored_cats != undefined) {
                this.fullCategoriesArr = JSON.parse(stored_cats);
                return this.fullCategoriesArr;
            }
        }
        return [];
    }

    loadCustomerInfo() {

        this.mcustomerService.getCustomerInfo().subscribe(result => {

            this.customer = result;
            this.authService.EmitUserLoggedIn(this.customer);

        });


    }


    getNewGuestCart() {

        // make sure token is set to null
        localStorage.setItem('t', null);
        localStorage.setItem('customer_type', 'guest');

        return this.cartService.getGuestCartQuote_id().pipe(
            concatMap(quote_id => {
                this.Quote_id = quote_id;
                // store it.
                this.cartService.setCachedCartId('guest', quote_id);
                return this.cartService.getGuestCart(quote_id, this.getWebsiteId());
            }),
            concatMap(cart => {

                this.cart = cart;
                this.cart.quoteId = this.Quote_id;
                this.cart.cartType = 'guest';
                return of(cart);

            }));

    }


    setupCustomer(): Observable<any> {
        this.wishList = null;
        const ctype = localStorage.getItem('customer_type');
        const cartId = localStorage.getItem('cartId');
        if (ctype === '' || ctype === 'guest' || ctype === undefined || ctype === 'null') {

            if (cartId === undefined || cartId === '' || cartId === 'null') {

                // localStorage.setItem('wishlist', JSON.stringify(this.wishList));
                // this.wishlistService.EmitWishListUpdated(this.wishList);

                return this.getNewGuestCart();

            } else {

                return this.cartService.getGuestCart(cartId, this.getWebsiteId()).pipe(
                    concatMap(cart => {
                        this.cart = cart;
                        // fire an event

                        this.cart.cartType = 'guest';
                        this.cart.quoteId = cartId;
                        this.Quote_id = cartId;
                        this.cartService.EmitCartUpdated(this.cart);

                        return of(cart);
                    }),
                    catchError((error, caught) => {

                        return this.getNewGuestCart();

                    })
                );

            }
        } else {

            return this.mcustomerService.getCustomerInfo()
                .pipe(
                    concatMap(customer => {
                            this.customer = customer;

                            localStorage.setItem('current_customer', JSON.stringify(this.customer));

                            return (this.cartService.getCustomerCart(this.getWebsiteId()));
                            //  return of(customer)
                        }
                    ),
                    concatMap(cart => {

                        if (cart == null) { // failed to load the current customer cart, generate new guest cart .

                        } else {
                            this.cart = cart;
                            // console.log(this.cart);
                            this.cart.quoteId = this.cart.id.toString();
                            this.Quote_id = this.cart.id.toString();
                            this.cart.cartType = 'user';


                            this.wishlistService.getCustomerWishlist().subscribe(wishlist => {
                                this.wishList = wishlist;
                                localStorage.setItem('wishlist', JSON.stringify(this.wishList));

                                this.cartService.setCachedCartId('user', this.cart.id);

                                this.cartService.EmitCartUpdated(this.cart);
                                // this.wishlistService.EmitWishListUpdated(this.wishList);
                                this.EmitCustomerLoaded(this.customer);

                            });
                            return of(cart);

                        }


                    }),

                    catchError((err, caught) => {

                        if (err.status === 401) {
                            // expired token.. switch as guest
                            return this.getNewGuestCart();
                        } else { //404
                            return (this.cartService.createCustomerCart()).pipe(
                                concatMap(cart => {
                                    this.cart = cart;
                                    this.EmitCustomerLoaded(this.customer);
                                    this.cart.quoteId = this.cart.id.toString();
                                    this.Quote_id = this.cart.id.toString();
                                    this.cart.cartType = 'user';
                                    this.cartService.setCachedCartId('user', this.cart.id);

                                    this.cartService.EmitCartUpdated(this.cart);

                                    return of(cart);
                                }));
                        }
                        // return this.getNewGuestCart();

                    })
                );
        }

        return of(true);
    }

    getExchangeRate() {


        if (this.currency_data == null) {
            return 1;
        }

        for (var i = 0; i < this.currency_data.exchange_rates.length; i++) {

            if (this.currency_data.exchange_rates[i].currency_to == this.current_currency) {
                return this.currency_data.exchange_rates[i].rate;
            }

        }

    }


    /***** events **/
    EmitCustomerLoaded(customer: Customer) {
        this.CustomerLoadedEventEmitter.next(customer);
    }

    EmitCatsLoadedEvent(cats
    ) {
        this.CatsLoadedEventEmitter.next(cats);
    }

    EmitConfigsLoadedEvent(configs
    ) {
        this.ConfigsLoadedEventEmitter.next(configs);
    }

    EmitCustomerAddressAdded(address: CustomerAddress) {
        this.CustomerAddressAddedEventEmitter.next(address);
    }

    EmitCurrencyLoadedEvent(currency_data: any) {
        this.CurrencyLoadedEventEmitter.next(currency_data);
    }

    EmitCurrencyChangedEvent(selected_currency: any) {
        this.CurrencyChangedEventEmitter.next(selected_currency);
    }

    EmitSettingsLoadedEvent(settings: any) {
        this.SettingsLoadedEventEmitter.next(settings);
    }


}
